<script>
  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";

  /* Components */
  import Logo from "../Logo.svelte";
  import Search from "./Search.svelte";
  import Filter from "./Filter.svelte";

  /* Constants */
  import Anchors from "../../constants/links";

  /* Functions */
  const switchMode = () => {
    storeGlobal.updateItem('darkMode', !$storeGlobal.darkMode);
  }
</script>

<!-- Header -->
<header class="static
               w-full
               bg-white
               border-b
               border-smoke
               dark:bg-blackd
               dark:border-slate"
        role="banner">

  <!-- Inner wrapper -->
  <div class="relativ flex justify-between py-4 px-8 mx-auto">

    <!-- left container -->
    <div class="flex items-center w-2/3 lg:w-3/5 xl:w-2/5">

      <!-- Identity -->
      <Logo/>

      <!-- Search -->
      <div class="w-full ml-6">
        <Search/>
      </div>
    </div>

    <!-- right container / Navigation -->
    <nav class="flex items-center">
      {#each Anchors as anchor}
        <a class="inline-block
                  text-silver
                  p-2
                  hover:text-slate
                  transition-colors
                  duration-200
                  ease-in-outline
                  outline-none
                  capitalize
                  dark-hover:text-teal"
           href="{ anchor.url }">

          { anchor.text }
        </a>
      {/each}

      <button class="focus:outline-none ml-2" on:click={ switchMode }>
        {#if $storeGlobal.darkMode }
          <svg class="w-5 h-5 stroke-current text-yellow_d" fill="none" stroke-linecap="round"
               stroke-linejoin="round" stroke-width="2" viewBox="0 0 10.286 10.286"
               xmlns="http://www.w3.org/2000/svg">
            <circle cx="5.1286" cy="5.1571" r="2.1403" stroke-width=".85619"/>
            <g stroke-width=".85613">
              <path d="M5.1286.4484v.8561M5.1286 9.0097v.8561M1.7983 1.8268l.6078.6078M7.8511
                       7.8796l.6078.6078M.41992 5.1571H1.276M8.9812 5.1571h.8561M1.7983
                       8.4874l.6078-.6078M7.8511 2.4346l.6078-.6078"/>
            </g>
          </svg>
        {:else}
          <svg class="w-5 h-5 stroke-current text-steel" fill="none" stroke-linecap="round"
               stroke-linejoin="round" stroke-width="2" viewBox="0 0 10.286 10.286"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M9.7698 5.5665A4.643 4.643 0 114.7192.5159a3.6113 3.6113 0 005.0506
                     5.0506z" stroke-width="1.0318"/>
          </svg>
        {/if}
      </button>
    </nav>

  </div>

  <!-- Filters -->
  <Filter/>

</header>
